import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0217',
    ecrans: ['00-2'],
    params: ['id']
});
